module.exports = __webpack_public_path__ + "static/media/community-gardens-data.31ee743b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/community-gardens-data.jpg
// module id = 714
// module chunks = 13